export default "__VITE_ASSET__Bb2A7OFR__"